/**
 * Sprint 24 — DangerZone primitive.
 *
 * A bordered-off destructive action (e.g. "Remove connection") with an explainer
 * and a confirmation step via the shared ConfirmModal. Reused by the MCP detail,
 * Wrapped detail, and (later) the agent Settings refactor.
 */

import { useState, type CSSProperties } from "react";
import { ConfirmModal } from "../primitives";

export interface DangerZoneProps {
  label: string;
  explainer?: string;
  /** Confirmation modal copy. */
  confirmTitle?: string;
  confirmMessage?: string;
  confirmLabel?: string;
  onConfirm: () => void | Promise<void>;
}

export function DangerZone({
  label,
  explainer,
  confirmTitle,
  confirmMessage,
  confirmLabel,
  onConfirm,
}: DangerZoneProps) {
  const [open, setOpen] = useState(false);

  return (
    <div style={wrap}>
      <button type="button" style={btn} onClick={() => setOpen(true)}>
        {label}
      </button>
      {explainer && <span style={explainerStyle}>{explainer}</span>}
      <ConfirmModal
        open={open}
        onOpenChange={setOpen}
        title={confirmTitle ?? label}
        message={confirmMessage ?? "This action cannot be undone."}
        confirmLabel={confirmLabel ?? label}
        variant="danger"
        onConfirm={onConfirm}
      />
    </div>
  );
}

const wrap: CSSProperties = {
  borderTop: "0.5px solid var(--color-border-tertiary)",
  paddingTop: 12,
  display: "flex",
  gap: 8,
  alignItems: "center",
  fontFamily: "var(--font-sans)",
};

const btn: CSSProperties = {
  padding: "6px 12px",
  fontSize: 12,
  color: "var(--color-text-danger)",
  border: "0.5px solid var(--color-border-tertiary)",
  borderRadius: "var(--border-radius-sm)",
  background: "transparent",
  cursor: "pointer",
  fontFamily: "var(--font-sans)",
  flexShrink: 0,
};

const explainerStyle: CSSProperties = {
  fontSize: 11,
  color: "var(--color-text-tertiary)",
};
